import React, { Component } from "react"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import Grow from "@mui/material/Grow"
import Typography from "@mui/material/Typography"
import CircularProgress from "@mui/material/CircularProgress"
import { withTranslation } from "react-i18next"
import { millisecondsToTime } from "../../utilities"

export default withTranslation()(
  class ExperienceInformationDialog extends Component {
    state = { loading: false, info: null }

    fetchInfo = async (experienceId, roomId) => {
      if (!this.fetchInfo.locked) {
        this.fetchInfo.locked = true

        this.setState({ loading: true })

        let info = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/experiences/${experienceId}/rooms/${roomId}/info?password=` +
            localStorage.getItem("password")
        )
          .then(async (response) => {
            if (response.status !== 200) {
              return []
            }

            return await response.json()
          })
          .catch(() => null)

        this.setState({ info, loading: false })

        this.fetchInfo.locked = false
      }
    }

    componentWillReceiveProps({ open, roomId: nextRoomId }) {
      const { prevRoomId, experienceId } = this.props
      const { info } = this.state

      if (open && prevRoomId !== nextRoomId && !info) {
        this.fetchInfo(experienceId, nextRoomId)
      }
    }

    render() {
      const { open, close, t } = this.props
      const { loading, info } = this.state

      return (
        <Dialog
          open={open}
          onClose={close}
          TransitionComponent={Grow}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            className="notSelectable"
            style={{ fontWeight: 600 }}
          >{t`Completion times`}</DialogTitle>
          <DialogContent
            style={{ paddingBottom: 0, textTransform: "none" }}
            className="notSelectable"
          >
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  margin: "16px",
                }}
              >
                <CircularProgress />
              </div>
            ) : info ? (
              <DialogContentText style={{ color: "#181818" }}>
                {info.slideCompletionTimes ? (
                  Object.entries(info.slideCompletionTimes).map((slide) => {
                    return (
                      <>
                        <b>{slide[0]}:</b>{" "}
                        {millisecondsToTime(slide[1]) || t`Unavailable`}
                        <br />
                      </>
                    )
                  })
                ) : (
                  <font
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        margin: "16px 32px",
                        color: "#181818",
                      }}
                    >
                      {t`No data for this room`}
                    </Typography>
                  </font>
                )}
              </DialogContentText>
            ) : (
              <font
                style={{
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    margin: "16px 32px",
                    color: "#181818",
                  }}
                >
                  {t`Something went wrong`}
                </Typography>
              </font>
            )}
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={close}>{t`Close`}</Button>
          </DialogActions>
        </Dialog>
      )
    }
  }
)
